// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../../state/criteria';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import FiscalYearCriteria from './fiscal-year-criteria';
import TerritoryCriteria from './territory-criteria';

const AuditSummaryInputCriteria = props =>
    <div className='audit-summary-input-criteria'>
        <div className='row'>
            <TerritoryCriteria
                allowedTerritories={props.allowedTerritories}
                onSelectAllTerritories={props.handleSelectAllTerritories}
                onSelectTerritory={props.handleTerritorySelect}
                selectedTerritories={props.criteria.territories}
            />
            <FiscalYearCriteria
                fiscalYearValue={props.criteria.fiscalYear}
                handleInputChange={props.handleFiscalYearSelect}
            />
        </div>
    </div>;

AuditSummaryInputCriteria.displayName = 'AuditSummaryInputCriteria';
AuditSummaryInputCriteria.propTypes = {
    allowedTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleFiscalYearSelect: PropTypes.func.isRequired,
    handleSelectAllTerritories: PropTypes.func.isRequired,
    handleTerritorySelect: PropTypes.func.isRequired
};

export default AuditSummaryInputCriteria;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/components/audit-summary-report-criteria/input-criteria.js